import { format as _format, parseISO } from "date-fns"

export const formatDate = (date: string, format = "LLLL d, yyy"): string => {
	return _format(parseISO(date), format)
}
